import { getApiClient } from '@signalvote/api-client';
import type { CreateTagRequest, UpdateTagRequest, VoterTagDto } from '@signalvote/shared';
import { defineQuery, defineWrite, requireSelectedCampaign } from '@/lib/data';

export interface UpdateTagData {
  id: number;
  updates: UpdateTagRequest;
}

/**
 * The campaign's voter tags. The read declares its GET's reads, so a tag write, or a tag added to
 * or taken off a voter, refreshes it with no key listed.
 */
export const useTags = defineQuery({
  key: () => ['tags', 'list'],
  reads: 'GET /api/VoterTags',
  fetch: (_: undefined, { campaignId }): Promise<VoterTagDto[]> => {
    requireSelectedCampaign(campaignId);
    return getApiClient().voterTags.getTags();
  },
});

export const useCreateTag = defineWrite({ send: (data: CreateTagRequest) => getApiClient().voterTags.createTag(data) });

export const useUpdateTag = defineWrite({ send: ({ id, updates }: UpdateTagData) => getApiClient().voterTags.updateTag(id, updates) });

export const useDeleteTag = defineWrite({ send: (id: number) => getApiClient().voterTags.deleteTag(id) });
